import React, { Suspense, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom'
import Loading from './components/Loading'
import './scss/style.scss'
import {
  addFirebaseToken,
  deleteFirebaseToken,
  loadFromLocalStorage,
} from './views/services/loginService'
import { checkFirebaseToken } from './firebase'
import { toast } from 'react-toastify'
import { shouldUpdate } from './views/services/httpService'
import { getVersion } from './views/services/commonServices'

const loading = (
  // <div className="pt-3 text-center">
  //   <div className="sk-spinner sk-spinner-pulse"></div>
  // </div>
  <Loading width={80} height={80} accentColor="red" isLoading={true} caption="در حال انتقال..." />
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages

const Update = React.lazy(() => import('./views/login/Update'))
const Login = React.lazy(() => import('./views/login/Login'))
const Mobile = React.lazy(() => import('./views/login/Mobile'))
const RegisterForm = React.lazy(() => import('./views/login/RegisterUser'))
const MobileVerification = React.lazy(() => import('./views/login/MobileVerification'))
const RecoverPassword = React.lazy(() => import('./views/login/RecoverPassword'))
const App = () => {
  const isLoading = useSelector((state) => state.loading)
  const isUserAuthenticatedRedux = useSelector((state) => state.isUserAuthenticated)
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    localStorage.getItem('access_token'),
  )
  const [shouldUpdateApp, setShouldUpdateApp] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    checkForUpdate()
  }, [])

  const checkForUpdate = () => {
    try {
      getVersion().then((response) => {
        if (response?.data) {
          //check version
          let serverUpdateObj = response?.data

          let clientVersion = process.env?.REACT_APP_VERSION
          let serverVersion = serverUpdateObj?.Version

          if (clientVersion !== serverVersion) {
            if (serverUpdateObj?.HasUpdate && !serverUpdateObj?.IsForceUpdate) {
              //optional Update
              sessionStorage.setItem('update', 'optional')
              setShouldUpdateApp(false)
            } else if (serverUpdateObj?.IsForceUpdate) {
              //Critical Update
              sessionStorage.setItem('update', 'critical')
              setShouldUpdateApp(true)
            } else {
              sessionStorage.clear()
              setShouldUpdateApp(false)
            }
            sessionStorage.setItem('newVersion', serverUpdateObj?.Version)
            sessionStorage.setItem('url', serverUpdateObj?.Url)
          } else {
            sessionStorage.clear()
            setShouldUpdateApp(false)
          }
        }
      })
    } catch (ex) {}
  }

  useEffect(() => {
    const token = loadFromLocalStorage('access_token')
    if (token) {
      setIsUserAuthenticated(true)

      const imageArray = loadFromLocalStorage('user_image')
      dispatch({ type: 'set', profileImage: imageArray })
    } else {
      setIsUserAuthenticated(isUserAuthenticatedRedux)
    }
  }, [isUserAuthenticatedRedux])

  useEffect(() => {
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'notifications' }).then(async (status) => {
        await Notification.requestPermission()

        status.onchange = async () => {
          if (status?.state === 'granted') {
            //should refresh by user
            //send fbtoken to server
            let fbToken = await checkFirebaseToken()
            await addFirebaseToken(fbToken)
          } else if (status?.state === 'denied') {
            //remove listener token server and local storage
            await deleteFirebaseToken()
          }
        }
      })
    }
  }, [])

  useEffect(() => {
    const networkCheck = () => {
      if (!navigator.onLine) {
        toast.error('عدم اتصال به اینترنت!', { autoClose: false })
      }
    }
    window.addEventListener('offline', networkCheck, false)

    return () => window.removeEventListener('offline', networkCheck, false)
  }, [])

  return (
    <>
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            {shouldUpdateApp ? (
              <Route path="*" name="Update" element={<Update />} />
            ) : isUserAuthenticated ? (
              <Route path="*" name="Home" element={<DefaultLayout />} />
            ) : (
              <>
                <Route exact path="/" name="Login Page" element={<Login />} />
                <Route exact path="/Login" name="Login Page" element={<Login />} />
                <Route exact path="/Mobile" name="Register Page" element={<Mobile />} />
                <Route
                  exact
                  path="/MobileVerification"
                  name="MobileVerification"
                  element={<MobileVerification />}
                />
                <Route
                  exact
                  path="/RecoverPassword"
                  name="RecoverPassword"
                  element={<RecoverPassword />}
                />
                <Route exact path="/Register" name="Register Form" element={<RegisterForm />} />
                <Route exact path="*" name="Login Page" element={<Navigate to="/Login" />} />
              </>
            )}
          </Routes>
          {/* <Navigate to="/Login" /> */}
        </Suspense>
      </HashRouter>
      <Loading
        width={80}
        height={80}
        accentColor="red"
        isLoading={isLoading}
        caption={'در حال بارگذاری'}
      />
    </>
  )
}

export default App
